import { render, staticRenderFns } from "./patientVisitMedical.vue?vue&type=template&id=c5096cd0&"
import script from "./patientVisitMedical.vue?vue&type=script&lang=js&"
export * from "./patientVisitMedical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports